import type { Category, ExportMode, Source, StepKey } from '@/types/documents.types';

/** Colour of a category key the caller has no metadata for (a deleted or unknown category). */
export const UNKNOWN_CATEGORY_COLOR = '#5b6b7c';

/**
 * A light tint mixed from a colour, for the rare case the backend sent none (a category unknown to
 * the snapshot); every known category carries its own `tint`.
 */
export const categoryTint = (color: string | undefined): string =>
  `color-mix(in srgb, ${color || UNKNOWN_CATEGORY_COLOR} 10%, white)`;

/**
 * The label for a category: the backend's `label_cs` (categories are rows an admin can rename), the
 * bare key when the snapshot does not know it.
 */
export const categoryLabel = (category: Category, labelCs: string | undefined): string => labelCs || category;

export const sourceLabelKey = (source: Source): string => `sources.${source}`;

export const stepLabelKey = (step: StepKey): string => `steps.${step}`;

export const modeLabelKey = (mode: ExportMode): string => `modes.${mode}`;
